import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToClassFromExist } from 'class-transformer';
import * as moment from 'moment';
import { GetOfficeEquipmentsInput, OfficeEquipmentInput, OfficeEquipmentResult, Result, ResultList, SingleResult } from '../models';
import { Utility } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class OfficeEquipmentService {

  constructor(private httpClient: HttpClient) { }

  public addOfficeEquipment(officeEquipmentInput: OfficeEquipmentInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipment/AddOfficeEquipment', officeEquipmentInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editOfficeEquipment(id: number, officeEquipmentInput: OfficeEquipmentInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'OfficeEquipment/EditOfficeEquipment?id=' + id, officeEquipmentInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editOfficeEquipmentReturnDateTime(id: number): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipment/EditOfficeEquipmentReturnDateTime', id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteOfficeEquipment(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'OfficeEquipment/DeleteOfficeEquipment?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getOfficeEquipment(id: number): Promise<SingleResult<OfficeEquipmentResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'OfficeEquipment/GetOfficeEquipment?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<OfficeEquipmentResult>(OfficeEquipmentResult), result))
      .catch(result => plainToClassFromExist(new SingleResult<OfficeEquipmentResult>(OfficeEquipmentResult), result.error));
  }

  public getOfficeEquipments(getOfficeEquipmentsInput: GetOfficeEquipmentsInput): Promise<ResultList<OfficeEquipmentResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipment/GetOfficeEquipments', getOfficeEquipmentsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<OfficeEquipmentResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<OfficeEquipmentResult>(), result.error));
  }

  public getOfficeEquipmentsExportToExcel(getOfficeEquipmentsInput: GetOfficeEquipmentsInput): Promise<SingleResult<Uint8Array>> {
    return this.httpClient.post(Utility.serviceAddress + 'OfficeEquipment/GetOfficeEquipmentsExportToExcel', getOfficeEquipmentsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result))
      .catch(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result.error));
  }
}
